import { useContext, useEffect, useMemo } from 'react'
import { PageContext } from '@providers/PageContext'
import { useModuleContext } from '../contexts/module'

export const TYPE_YOUTUBE = 'youtube'
export const TYPE_VIMEO = 'vimeo'

function useVideos() {
  const { page: { pageData } } = useContext(PageContext)
  // @ts-ignore
  const { dispatch } = useModuleContext()

  const id = pageData.videoId
  const isVideoSet = !!pageData.videoId
  const videoType = pageData.videoType === 0 ? TYPE_YOUTUBE : TYPE_VIMEO
  const videoUrl =
    videoType === TYPE_YOUTUBE
      ? `https://www.youtube.com/watch?v=${pageData.videoId}`
      : `https://vimeo.com/${pageData.videoId}`

  const data = useMemo(() => ({
    id,
    isVideoSet,
    videoType,
    videoUrl
  }), [id, isVideoSet, videoType, videoUrl])

  useEffect(() => {
    if (pageData) {
      dispatch({
        type: 'SET_VIDEOS',
        payload: data
      })
    }
  }, [data, dispatch, pageData])
}

export default useVideos
